import { render, staticRenderFns } from "./HousesAdd.vue?vue&type=template&id=1b020c67&scoped=true&"
import script from "./HousesAdd.vue?vue&type=script&lang=js&"
export * from "./HousesAdd.vue?vue&type=script&lang=js&"
import style0 from "./HousesAdd.vue?vue&type=style&index=0&id=1b020c67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b020c67",
  null
  
)

component.options.__file = "HousesAdd.vue"
export default component.exports